export enum FeatureType {
	WATERFALL_SALE = "waterfall-sale",
	CLUB_GIFT_BONUS_V2 = "club-gift-bonus-v2",
	CLUB_FREE_GIFT = "club-free-gift",
	SIGN_UP_INCENTIVE = "scopely-connect",
	DRIP_OFFER = "drip-offer",
	BUNDLE_UP = "upsell",
	REBATE_OFFER = "rebate",
	POIS_BOUNTY_V3 = "poisBounty/v3",
	FRIEND_REFERRAL = "friend/referral"
	//OTHER_FEATURE_TYPE = "other-feature-type"
}
